import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material";
import { COLORS } from "../../constants";

const AccordionTitle = styled(Typography)(({ theme }) => ({}));
const CustomAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
    padding: "0"
}));

export const SelectExercisesAccordion = <T,>({
  groups,
  children,
  getGroupLabel,
}: {
  groups: T[];
  children: (subItem: any, index: number) => React.ReactNode;
  getGroupLabel: (group: T) => string;
}) => {
  return (
    <div>
      {groups.map((group, groupIndex) => (
        <Accordion key={groupIndex}>
          <AccordionSummary
            sx={{ backgroundColor: COLORS.DIDACTO_DARK_GREY }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-${groupIndex}-content`}
            id={`panel-${groupIndex}-header`}
          >
            <AccordionTitle>{getGroupLabel(group)}</AccordionTitle>
          </AccordionSummary>
          <CustomAccordionDetails>{children(group, groupIndex)} </CustomAccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
